import { Icon } from "@material-ui/core";
import Button from "Components/Common/Button/Button";
import Toolbar from "Components/Common/Toolbar/Toolbar";
import ContentView from "Components/ContentView/ContentView";
import RouterLink from "Components/RouterLink/RouterLink";
import { RouterLinkType } from "Enums/RouterLinkType";
import { DataState } from "Models/Common/DataState";
import { TaskTemplate } from "Models/Tasks/TaskTemplate";
import * as React from "react";
import { connect } from "react-redux";
import { IApplicationState } from "Store/Store";
import { ITaskTemplateState } from "Store/TaskTemplates/TaskTemplateState";
import i18n from "Translations/i18n";
import styles from "./TaskTemplateDetailHeader.scss";

const mapStateToProps = (state: IApplicationState) => ({
    taskTemplateState: state.taskTemplateState
});

interface IProps {
    taskTemplateState: ITaskTemplateState;
    taskTemplate: TaskTemplate;
    duplicate: () => void;
    onTaskDeletedClicked(): void;
    save: () => void;
    saveAndAddAnother: () => void;
}

interface IState {
    isSaving: boolean;
    isDuplicating: boolean;
    isDeleting: boolean;
    createNewAfterSave: boolean;
}
export class TaskTemplateDetailHeader extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            isSaving: false,
            isDuplicating: false,
            isDeleting: false,
            createNewAfterSave: false
        };

        this.save = this.save.bind(this);
        this.saveAndAddAnother = this.saveAndAddAnother.bind(this);
        this.duplicate = this.duplicate.bind(this);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.taskTemplateState.detailTaskTemplateStates &&
            (nextProps.taskTemplateState.detailTaskTemplateStates[nextProps.taskTemplate.id || -1] === DataState.Saving) !== prevState.isSaving) {
            partialState.isSaving = nextProps.taskTemplateState.detailTaskTemplateStates[nextProps.taskTemplate.id || -1] === DataState.Saving;
            if (!partialState.isSaving) {
                partialState.isDuplicating = false;
            }
        }
        else if (nextProps.taskTemplateState.detailTaskTemplateStates &&
            (nextProps.taskTemplateState.detailTaskTemplateStates[nextProps.taskTemplate.id || -1] === DataState.Deleting) !== prevState.isDeleting) {
            partialState.isDeleting = nextProps.taskTemplateState.detailTaskTemplateStates[nextProps.taskTemplate.id || -1] === DataState.Deleting;
        }

        return partialState;
    }

    public save() {
        this.setState({ createNewAfterSave: false });
        this.props.save();
    }

    public saveAndAddAnother() {
        this.setState({ createNewAfterSave: true });
        this.props.saveAndAddAnother();
    }

    public duplicate() {
        this.setState({ isDuplicating: true });
        this.props.duplicate();
    }

    public render() {
        return (
            <ContentView className={styles.taskTemplateDetailHeader}>
                <Toolbar>
                    <Button id="btnDuplicate" onClick={this.duplicate} disabled={this.state.isSaving || this.state.isDeleting || this.state.isDuplicating || !this.props.taskTemplate.id}>
                        <Icon>file_copy</Icon>
                        {i18n.t("common.duplicate")}
                    </Button>
                    <Button id="btnDelete" onClick={this.props.onTaskDeletedClicked} isLoading={this.state.isDeleting} disabled={this.state.isSaving || this.state.isDeleting || this.state.isDuplicating || !this.props.taskTemplate.id}>
                        <Icon>delete</Icon>
                        {i18n.t("common.delete")}
                    </Button>
                    <Button id="btnSave" onClick={this.save} isLoading={this.state.isSaving && !this.state.createNewAfterSave} disabled={this.state.isSaving || this.state.isDeleting}>
                        <Icon>check</Icon>
                        {i18n.t("common.save")}
                    </Button>
                    <Button id="btnSaveAndAddAnother" onClick={this.saveAndAddAnother} isLoading={this.state.isSaving && this.state.createNewAfterSave} disabled={this.state.isSaving || this.state.isDeleting}>
                        <Icon>check</Icon>
                        {i18n.t("common.saveAndAddAnother")}
                    </Button>
                </Toolbar>
                <RouterLink type={RouterLinkType.default} to="/tasktemplates" className={styles.backToOverview}>
                    <Icon className={styles.icon}>arrow_back</Icon>
                    {i18n.t("tasks.backToOverview")}
                </RouterLink>
                <h1>{i18n.t("tasks.detailsTitle")}</h1>
            </ContentView>
        );
    }
}

export default connect(mapStateToProps)(TaskTemplateDetailHeader);


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateDetailView/TaskTemplateDetailHeader/TaskTemplateDetailHeader.tsx